import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import {Container, Row, Col, Card, Button} from "react-bootstrap";
import { useAccounts } from "../../contextjs/AccountContext";
import IncomeExpenseDailyChart from "./reportsmodules/incomeexpensechart";
import { fetchUserDetails, apiInstance } from "../../api/api"

const AccountingHomepage = () => {
    const {accounts, fetchAccountsData} = useAccounts();
    const [assetAccounts, setAssetAccounts] = useState([]);
    const [totalCurrentAssets, setTotalCurrentAssets] = useState(0);
    const [isAdmin, setIsAdmin] = useState(false);
    const [activeFY, setActiveFY] = useState(null);

    useEffect(() => {
        // fetch accounts only when the component mounts, don't add to the below useEffect since it will cause an infinite loop
        fetchAccountsData();
    }, [fetchAccountsData]);

    useEffect(() => {
      apiInstance.get('/financial-years/active/')
        .then(res => setActiveFY(res.data))
        .catch(() => setActiveFY(null));
    }, []);

    useEffect(() => {
        // fetch user role once
        fetchUserDetails()
            .then(user => {
                setIsAdmin(user.is_superuser === true);
            })
            .catch(() => setIsAdmin(false));
    }, [fetchAccountsData]);

    useEffect(() => {
        if (accounts.length > 0) {
            // filter accounts by name or type
            const filteredAccounts = accounts.filter(account =>
                ["Cash", "Kenya Commercial Bank (KCB)", "Equity Bank", "George Mpesa", "Mpesa Till Account",
                    "NCBA Bank"].includes(account.account_name)
            );
            setAssetAccounts(filteredAccounts);

            // calculate total current assets
            const total = filteredAccounts.reduce(
                (sum, account) => sum + Number(account.computed_balance || 0),
                0
            );
            setTotalCurrentAssets(total);
        }
    }, [accounts]);


    return (
        <Container className="mt-5">
            {/*financial year status*/}
            {activeFY && (
            <Card className="mb-3 bg-light">
                <Card.Body className="d-flex justify-content-between align-items-center">
                    <div>
                        <strong>Active Financial Year:</strong> {activeFY.name}
                        <br />
                        <small>
                            {activeFY.start_date} - {activeFY.end_date}
                        </small>
                    </div>

                    {isAdmin && (
                        <Link to="/accounting/financial-years">
                            <Button variant="outline-danger" size="sm">
                                Manage Financial Years
                            </Button>
                        </Link>
                    )}
                </Card.Body>
            </Card>
            )}

            <h1 className="text-center mb-4">Accounting Dashboard</h1>
            <Row>
                {/*income expense bar graph*/}
                <Col md={9} className="mb-4">
                    <IncomeExpenseDailyChart />
                </Col>
                {/*asset balances card*/}
                <Col md={3} className="mb-4">
                    <Card className="text-white bg-info">
                        <Card.Body>
                            <Card.Title>Current Asset Balances</Card.Title>
                            {assetAccounts.map(( account, index) => (
                                <Card.Text key={index}>
                                    {account.account_name}: Ksh {parseFloat(account.computed_balance).toLocaleString()}
                                </Card.Text>
                            ))}
                            {/*<Card.Title>Current Asset Balances</Card.Title>*/}
                            <Card.Text className="font-weight-bold">
                                Total current assets: Ksh {totalCurrentAssets.toLocaleString()}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row>
                <Col md={4} className="mb-4">
                    <Link to="/accounting/accounts" className="text-decoration-none">
                        <Card className="text-white bg-primary">
                            <Card.Body>
                                <Card.Title>Accounts</Card.Title>
                                <Card.Text>View and manage accounts</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col md={4} className="mb-4">
                    <Link to="/accounting/transactions" className="text-decoration-none">
                        <Card className="text-white bg-success">
                            <Card.Body>
                                <Card.Title>Transactions</Card.Title>
                                <Card.Text>View and record transactions</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col md={4} className="mb-4">
                    <Link to="/accounting/reports" className="text-decoration-none">
                        <Card className="text-white bg-warning">
                            <Card.Body>
                                <Card.Title>Reports</Card.Title>
                                <Card.Text>View accounting reports</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
            <Row>
                <Col md={4} className="mb-4">
                    <Link to="/accounting/budgets" className="text-decoration-none">
                        <Card className="text-white bg-info">
                            <Card.Body>
                                <Card.Title>Budgets</Card.Title>
                                <Card.Text>Manage budgets</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col md={4} className="mb-4">
                    <Link to="/accounting/payroll" className="text-decoration-none">
                        <Card className="text-white bg-danger">
                            <Card.Body>
                                <Card.Title>Payroll</Card.Title>
                                <Card.Text>Manage and view payroll</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
                <Col md={4} className="mb-4">
                    <Link to="/accounting/taxes" className="text-decoration-none">
                        <Card className="text-white bg-secondary">
                            <Card.Body>
                                <Card.Title>Taxes</Card.Title>
                                <Card.Text>Manage and view taxes</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
            <Row>
                <Col md={4} className="mb-4">
                    <Link to="/accounting/accountsauditlog" className="text-decoration-none">
                        <Card className="text-white bg-dark">
                            <Card.Body>
                                <Card.Title>Audit Log</Card.Title>
                                <Card.Text>View audit log</Card.Text>
                            </Card.Body>
                        </Card>
                    </Link>
                </Col>
            </Row>
        </Container>
    );
};

export default AccountingHomepage;